import { Button } from '../components/Button';
import { useI18n } from '../i18n/i18n-context';
import { useConsent } from '../lib/consent-context';

/**
 * Asks whether Lyrmo may count how the site is used, until the visitor chooses, and again when
 * they ask to change it. The cookies the site needs work either way; declining is as easy as
 * allowing, and nothing is counted as the visitor's before they allow it.
 */
export function CookieNotice() {
  const { t } = useI18n();
  const { asking, choose } = useConsent();

  if (!asking) return null;
  return (
    <section className="cookie-notice" aria-label={t.cookies.label}>
      <p className="cookie-notice-message">
        {t.cookies.message}{' '}
        <a className="cookie-notice-link" href="/privacy.html#cookies">
          {t.cookies.learnMore}
        </a>
      </p>
      <div className="cookie-notice-actions">
        <Button
          className="cookie-notice-button"
          onClick={() => {
            choose('insights');
          }}
        >
          {t.cookies.allow}
        </Button>
        <Button
          className="cookie-notice-button"
          onClick={() => {
            choose('necessary');
          }}
        >
          {t.cookies.decline}
        </Button>
      </div>
    </section>
  );
}
